var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPudding = function SvgPudding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pudding_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M59.882 53.632c0 1.17-.947 2.118-2.117 2.118H28.118A2.12 2.12 0 0 1 26 53.632v-.706h33.882zM44.706 25.397a1.412 1.412 0 1 0 0-2.824 1.412 1.412 0 0 0 0 2.824M41.176 25.397a1.412 1.412 0 1 0 0-2.824 1.412 1.412 0 0 0 0 2.824M42.941 22.574a1.412 1.412 0 1 0 0-2.824 1.412 1.412 0 0 0 0 2.823"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m28.988 37.69.541-5.234a7.06 7.06 0 0 1 7.06-7.059h12.705a7.06 7.06 0 0 1 7.059 7.059l.541 5.233M28.989 37.69l-1.577 15.236h31.059L56.894 37.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M28.988 37.69c.35.256.78.413 1.247.413 1.17 0 2.118-.949 2.118-2.118v-1.411a2.118 2.118 0 1 1 4.235 0v1.411a2.118 2.118 0 0 0 4.236 0v-1.411a2.118 2.118 0 1 1 4.235 0v1.411a2.118 2.118 0 0 0 4.235 0v-1.411a2.118 2.118 0 1 1 4.235 0v1.411c0 1.17.948 2.118 2.118 2.118.468 0 .897-.157 1.247-.414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pudding_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4483_45498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4483_45498",
    result: "shape"
  })))));
};
export default SvgPudding;